import { put, takeLatest, all, call, actionChannel, select } from 'redux-saga/effects'
import { buffers } from 'redux-saga'
import { setScreenError } from 'modules/tokenRefresh/actions'
import { signOut, getGuestToken } from 'modules/authentication/actions'
import jwtDecode from 'jwt-decode'
import { getJwtType } from 'modules/authentication/sagas'
import { actions, refreshTokenComplete, dispatchQueuedActions as dispatchActions } from './actions'
import { setJWT } from '../appSettings/actions'
import { newMapiRefreshTokenURL } from './urls'
import { api } from '../../network/api'
import { getJWTDetails, isEmpty } from '../../utils/appUtils'

const buffer = buffers.sliding()

function* refreshToken() {
    const { appSettings } = yield select()
    const isApp = appSettings.get('isApp')

    try {
        const { isSignedIn, token, refreshToken } = getJWTDetails()
        if (!isSignedIn) {
            yield put(getGuestToken())
            yield put(refreshTokenComplete())
            // Check if the guest token was updated in the reducer or not
            const guestToken = appSettings.get('jwt')
            if (guestToken) yield put(dispatchActions())
        } else {
            // If the user is signed in, try to refresh the token after doing token checks
            let refreshJwt = refreshToken
            if (isEmpty(refreshJwt)) {
                if (getJwtType(token)) {
                    const { refresh_token } = jwtDecode(token)
                    refreshJwt = refresh_token
                }
            }

            if (isEmpty(refreshJwt)) {
                throw new Error('NO RefreshToken')
            }
            if (!isApp) {
                const response = yield call(
                    api,
                    newMapiRefreshTokenURL,
                    'POST',
                    { refresh_token: refreshJwt },
                    0,
                    10,
                    true
                )
                const { access_token, refresh_token } = response
                if (!access_token) {
                    throw new Error('NO JWT IN refreshToken')
                }
                yield put(
                    setJWT({
                        access_token,
                        refresh_token,
                    })
                )
                yield put(refreshTokenComplete())
                yield put(dispatchActions())
            }
        }
    } catch (error) {
        yield put(refreshTokenComplete())
        if (isApp) {
            // call exposed 7-11 close method
            console.log('Error caught in catch', error)
            yield put(setScreenError(error))
        } else {
            yield put(signOut())
        }
    }
}

function* enqueueFailedActions() {
    yield actionChannel(actions.ENQUEUE_FAILED_ACTION, buffer)
}

function* dispatchQueuedActions() {
    while (!buffer.isEmpty()) {
        const { payload } = yield call(buffer.take)
        yield put(payload)
    }
}

//= ============================================================================================================

function* refreshTokenWatcher() {
    yield takeLatest(actions.REFRESH_TOKEN, refreshToken)
}

function* dispatchQueuedActionsWatcher() {
    yield takeLatest(actions.DISPATCH_QUEUED_ACTIONS, dispatchQueuedActions)
}

export default function* tokenRefreshSaga() {
    yield all([refreshTokenWatcher(), dispatchQueuedActionsWatcher(), enqueueFailedActions()])
}
